var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["category-h1.j2"] = require( "category-h1.j2" );
dependencies["category-product-count.j2"] = require( "category-product-count.j2" );
dependencies["category-browse-heading.j2"] = require( "category-browse-heading.j2" );
dependencies["category-expanded-filters-list.j2"] = require( "category-expanded-filters-list.j2" );
dependencies["category-sort-menu.j2"] = require( "category-sort-menu.j2" );
dependencies["category-paging.j2"] = require( "category-paging.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-grid-controls.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-category-above-grid o-row c-category-header ";
if(runtime.contextOrFrameLookup(context, frame, "filtersSelected")) {
output += "s-filters-list__outer";
;
}
output += "\">\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large")) {
output += "\n\n        <div class=\"g-category-browse__header-section\">\n\n            ";
env.getTemplate("category-h1.j2", false, "category/templates/category-grid-controls.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            ";
var t_5;
t_5 = (lineno = 8, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.products.totalRecordCount",0])) > 0;
frame.set("hasPositiveRecordCount", t_5, true);
if(frame.topLevel) {
context.setVariable("hasPositiveRecordCount", t_5);
}
if(frame.topLevel) {
context.addExport("hasPositiveRecordCount", t_5);
}
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.contextOrFrameLookup(context, frame, "hasPositiveRecordCount")) {
output += "\n\n                <div class=\"c-results-count-outer\">\n\n                    ";
env.getTemplate("category-product-count.j2", false, "category/templates/category-grid-controls.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n                </div>\n\n            ";
})});
}
output += "\n\n        </div>\n\n    ";
})});
}
output += "\n\n    ";
env.getTemplate("category-browse-heading.j2", false, "category/templates/category-grid-controls.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0) {
output += "\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium")) {
output += "\n            <div class=\"g-category-browse__expanded-filters-section c-category-expanded-filters__outer\">\n                ";
env.getTemplate("category-expanded-filters-list.j2", false, "category/templates/category-grid-controls.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n            </div>\n        ";
})});
}
output += "\n\n        <div class=\"g-category-browse__sort-section c-category-header-inner\">\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large")) {
output += "\n                <div class=\"g-category-browse__expanded-filters-section c-category-expanded-filters__outer\">\n                    ";
env.getTemplate("category-expanded-filters-list.j2", false, "category/templates/category-grid-controls.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n                </div>\n            ";
})});
}
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
env.getTemplate("category-sort-menu.j2", false, "category/templates/category-grid-controls.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
})});
}
else {
env.getTemplate("category-product-count.j2", false, "category/templates/category-grid-controls.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
})});
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"pageOptions") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"shouldDisplayResultsOptions")) {
output += "<div class=\"dom-paging-top u-extra-small--hide u-medium--show c-category-header__pagination-outer\" data-qa-paging-top>\n\n                    ";
var t_30;
t_30 = "TOP";
frame.set("categoryPagingLocation", t_30, true);
if(frame.topLevel) {
context.setVariable("categoryPagingLocation", t_30);
}
if(frame.topLevel) {
context.addExport("categoryPagingLocation", t_30);
}
output += "\n                    ";
env.getTemplate("category-paging.j2", false, "category/templates/category-grid-controls.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n                </div>";
})});
}
output += "</div>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-grid-controls.j2"] , dependencies)